<template>
  <div class="animal-filter" v-if="animalCategories.length > 1">
        <label class="btn" :class="{'':!checkedCategory}">
          <input type="radio"
                  name="animalFilter"
                  :value="0"
                  @change="update"
                  v-model="checkedCategory"
                  class="hidden">
          <div>Show all</div>
        </label>

        <label v-for="category in animalCategories" class="btn" :key="category.id" :class="{'':checkedCategory==category.id}">
            <input type="radio"
                    name="animalFilter"
                    class="hidden"
                    :value="category.id"
                    @change="update"
                    v-model="checkedCategory">
            <div>{{ category.title }}</div>
        </label>

  </div>
</template>


<script>
export default {

  data() {
    return {
      checkedCategory: 0,
    }
  },
  props: {
      animalCategories: {
        required: true,
        type: Array
      },
      initialCategory: {},
    },
  watch: {
    initialCategory(val) {
     this.checkedCategory = val;
    }
  },
  methods: {
    update() {
      this.$emit('updateCategory',this.checkedCategory);
    }
  }

}
</script>
